/**
 * Requires
 */

import Blazy from 'blazy'
import $ from 'jquery'

/**
 * Initialisation
 */

export const initialise = () => {
  const bLazy = new Blazy({
    selector: '.lazy',
    successClass: 'loaded',
    errorClass: 'error',
    success: el => {
      const parent = el.parentElement
      if (parent && parent.classList.contains('spinner')) {
        parent.classList.remove('spinner')
      }
    },
  })

  const $creditsToggle = $('[data-credits-toggle]')
  if ($creditsToggle) {
    $creditsToggle.on('click', () => {
      setTimeout(() => {
        bLazy.revalidate()
      }, 1)
    })
  }
}
